import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { placeholder } from 'src/app/models/placeholder';

@Component({
  selector: 'hero-banner',
  templateUrl: './hero-banner.component.html',
  styleUrls: ['./hero-banner.component.scss'],
})
export class HeroBannerComponent implements OnInit {
  @Input() bannerInfo: any;
  @Output() presentModal = new EventEmitter();
  public currentTime: string;
  public placeholder = placeholder;
  constructor() { }

  ngOnInit() {
    if (this.bannerInfo) {
      this.currentTime = new Date().toLocaleString('en-US', {
        timeZone: this.bannerInfo?.timeZoneRegionName,
      });
    }
  }
  openModal() {
    this.presentModal.emit();
  }
}
